import { render, staticRenderFns } from "./GroupMemberMapping.vue?vue&type=template&id=bb47462c&"
import script from "./GroupMemberMapping.vue?vue&type=script&lang=js&"
export * from "./GroupMemberMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports